"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CompareIcon = function CompareIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M7 5V0h1v5zM1 2h5V1H0v13h6v-1H1zm6 7v6h1V9zm2-8v2h1.399a1 1 0 0 1 .707.293l3.001 3a1 1 0 0 1 0 1.414l-3 3A1 1 0 0 1 10.4 11H9v3h6V1zm.999 3H9v1h1v1H5V5h1V4h-.999L2 7l3 3h1V9H5V8h5v1H9v1h1l3-3z"
    }) : _react["default"].createElement("path", {
      d: "M3.74 7h7.52L9.676 5.415l.707-.707 2.81 2.809-2.81 2.81-.707-.708L11.295 8h-7.59l1.62 1.62-.707.706-2.81-2.81 2.81-2.808.707.707zM1 2h5V1H0v13h6v-1H1zm14-1v13H9v-1.694l.668-.668a1.446 1.446 0 0 0 1.398.016L9.72 13h2.586L14 11.306V4.72l-.742.742-.707-.707L14 3.306V2h-1.28l-1.48 1.48a1.487 1.487 0 0 0-.858-.272 1.504 1.504 0 0 0-.32.037L11.306 2H9V1zm-1 11.72l-.28.28H14zM8 0H7v6h1zM7 15h1V9H7z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M10 22H0V2h10v1H1v18h9zm2-12V1h-1v9zm1-8v8h1.927l-.93-.952A1.5 1.5 0 0 1 15.07 6.5h2.154a1.49 1.49 0 0 1 1.06.44l4 4a1.501 1.501 0 0 1 0 2.12l-4 4a1.49 1.49 0 0 1-1.06.44H15.07a1.5 1.5 0 0 1-1.073-2.548l.93-.952H13v8h10V2zm-2 12v9h1v-9zm6.223-6H15.07L18 11H6l2.93-3H6.777l-4 4 4 4H8.93L6 13h12l-2.93 3h2.153l4-4z"
    }) : _react["default"].createElement("path", {
      d: "M11 9V1h1v8zm2 10.72l2.368-2.368-.014.002a1.998 1.998 0 0 1-1.08-.321L13 18.306zM11 14v9h1v-9zM1 3h9V2H0v20h10v-1H1zm22-1v20H13v-1h1.306L22 13.306V10.72l-.794.795a1.994 1.994 0 0 0-.318-1.096L22 9.306V6.72l-2.372 2.373-.707-.707 2.878-2.88.201-.2V3h-.28l-2.507 2.507-1.585 1.586-.707-.707.879-.88L20.305 3H17.72l-2.506 2.507-.171.17a1.995 1.995 0 0 0-1.104.555l-.707.707a2 2 0 0 0-.232.284v-.917l.8-.8L16.305 3H13.72l-.72.72V2zm-1 16.72L19.72 21H22zm0-4L15.72 21h2.586L22 17.306zM5.707 11l2.647-2.646-.707-.707L3.793 11.5l3.854 3.854.707-.707L5.707 12h11.586l-2.646 2.646.707.707 3.853-3.853-3.853-3.854-.707.707L17.293 11z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M14 28H1V3h13v1H2v23h12zm3-25v11h2.927l-.93-.952A1.5 1.5 0 0 1 20.07 10.5h2.154a1.49 1.49 0 0 1 1.06.44l4 4a1.501 1.501 0 0 1 0 2.12l-4 4a1.49 1.49 0 0 1-1.06.44H20.07a1.5 1.5 0 0 1-1.073-2.548l.93-.952H17v10h13V3zm-1 11V1h-1v13zm-1 4v12h1V18zm7.223-6H20.07L23 15H9l2.93-3H9.777l-4 4 4 4h2.153L9 17h14l-2.93 3h2.153l4-4z"
  }) : _react["default"].createElement("path", {
    d: "M24.288 15.544l-3.852 3.852-.707-.707 2.645-2.645H8.626l2.645 2.645-.707.707-3.852-3.852 3.854-3.855.707.707-2.647 2.648h13.748l-2.647-2.648.707-.707zm-6.705 4.179l-.583.583v1.414l1.061-1.06a2.557 2.557 0 0 1-.478-.937zm.102-6.687l-.044-.125a2.61 2.61 0 0 1-.118-1.128l-.523.523v1.138h.276zm2.398 8.607a2.605 2.605 0 0 1-.382-.037L17 24.306v1.414l4.5-4.499a2.581 2.581 0 0 1-1.417.422zM16 13V1h-1v12zM2 4h12V3H1v25h13v-1H2zm28-1v25H17v-1h1.306L29 16.306V13.72l-3.24 3.24a2.597 2.597 0 0 0 .383-1.797L29 12.306V9.72l-3.783 3.783-.707-.707L29 8.306V5.72l-5.783 5.783-.707-.707L29 4.306V4h-2.28l-.007.007L21.08 9.64a2.593 2.593 0 0 0-.998-.199c-.082 0-.16.016-.24.024l5.458-5.46.007-.006H22.72l-.007.007L17 9.72V8.306l4.3-4.3.006-.006H18.72l-.006.007L17 5.72V4.306l.3-.3.006-.006H17V3zm-1 22.72L27.72 27H29zm0-4L23.72 27h2.586L29 24.306zm0-4L19.72 27h2.586L29 20.306zm-14 .324V30h1V18.044z"
  }));
};

var _default = CompareIcon;
exports["default"] = _default;